export const LIST_ROW_CLICK_ACTION_FLAG = 'teacher_dash_list_row_click_action';
